import { apiRequest } from './apiWrapper'
import { isMobile } from 'react-device-detect'

export async function fetchLandingPage() {
    const response = await apiRequest({
        method: 'get',
        url: isMobile
            ? `landing_page/?title=vertical`
            : `landing_page/?title=Horizontal`
    })
    return response
}
